import React from 'react';

const EmptyActivityIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="102" height="100" viewBox="0 0 102 100" fill="none">
    <path
      d="M53.9086 52.2714C53.2006 51.5634 53.2006 50.4156 53.9086 49.7076L56.7275 46.8888C57.4355 46.1808 58.5833 46.1808 59.2913 46.8887L81.4046 69.002C82.1126 69.71 82.1126 70.8579 81.4046 71.5659L78.5858 74.3847C77.8778 75.0927 76.7299 75.0927 76.0219 74.3847L53.9086 52.2714Z"
      fill="#FD8F01"
      style={{ fill: '#FD8F01', fillOpacity: 1 }}
    />
    <path
      d="M64.5694 66.1982C63.3628 67.4049 63.3628 69.3612 64.5694 70.5679L86.6791 92.6776C87.8858 93.8843 89.8422 93.8843 91.0488 92.6776L99.6989 84.0275C100.906 82.8209 100.906 80.8645 99.6989 79.6578L77.5892 57.5481C76.3825 56.3415 74.4262 56.3415 73.2195 57.5481L64.5694 66.1982Z"
      fill="#FD8F01"
      stroke="#052A75"
      style={{ fill: '#FD8F01', fillOpacity: 1, stroke: '#052A75', strokeOpacity: 1 }}
      strokeWidth="2.55385"
    />
    <path
      d="M34.3457 27.298C34.3457 29.8446 33.2841 31.909 31.9744 31.909C30.6647 31.909 29.603 29.8446 29.603 27.298C29.603 24.7514 30.6647 22.687 31.9744 22.687C33.2841 22.687 34.3457 24.7514 34.3457 27.298Z"
      fill="#FDCB50"
      style={{ fill: '#FDCB50', fillOpacity: 1 }}
    />
    <path
      d="M49.628 27.298C49.628 29.8446 48.5663 31.909 47.2566 31.909C45.9469 31.909 44.8853 29.8446 44.8853 27.298C44.8853 24.7514 45.9469 22.687 47.2566 22.687C48.5663 22.687 49.628 24.7514 49.628 27.298Z"
      fill="#FDCB50"
      style={{ fill: '#FDCB50', fillOpacity: 1 }}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.1823 42.7956C39.4177 40.2673 34.9416 41.9023 33.5243 42.9174C33.1931 43.1546 32.7324 43.0784 32.4952 42.7473C32.258 42.4161 32.3342 41.9554 32.6653 41.7182C34.4977 40.4058 39.5245 38.7034 45.7748 41.4447C46.1478 41.6083 46.3176 42.0434 46.154 42.4164C45.9904 42.7895 45.5553 42.9592 45.1823 42.7956Z"
      fill="#FD8F01"
      style={{ fill: '#FD8F01', fillOpacity: 1 }}
    />
    <path
      d="M39.2787 62.4197C55.8787 62.4197 69.3357 48.9627 69.3357 32.3626C69.3357 15.7626 55.8787 2.3056 39.2787 2.3056C22.6786 2.3056 9.22161 15.7626 9.22161 32.3626C9.22161 48.9627 22.6786 62.4197 39.2787 62.4197ZM61.683 32.3626C61.683 44.7362 51.6522 54.767 39.2787 54.767C26.9051 54.767 16.8743 44.7362 16.8743 32.3626C16.8743 19.9891 26.9051 9.95828 39.2787 9.95828C51.6522 9.95828 61.683 19.9891 61.683 32.3626Z"
      fill="#FDCB50"
      stroke="#052A75"
      style={{ fill: '#FDCB50', fillOpacity: 1, stroke: '#052A75', strokeOpacity: 1 }}
      strokeWidth="2.55385"
    />
    <path
      d="M84.9194 44.1903C84.9194 46.1302 83.3467 47.7028 81.4068 47.7028C79.4669 47.7028 77.8943 46.1302 77.8943 44.1903C77.8943 42.2503 79.4669 40.6777 81.4068 40.6777C83.3467 40.6777 84.9194 42.2503 84.9194 44.1903Z"
      fill="#FDCB50"
      style={{ fill: '#FDCB50', fillOpacity: 1 }}
    />
    <path
      d="M1.11108 58.679L1.36853 58.0473L8.10593 60.7935L7.84848 61.4251L1.11108 58.679Z"
      fill="#FB554C"
      style={{ fill: '#FB554C', fillOpacity: 1 }}
    />
    <path
      d="M6.2959 56.4963L5.66427 56.2389L2.91813 62.9763L3.54976 63.2337L6.2959 56.4963Z"
      fill="#FB554C"
      style={{ fill: '#FB554C', fillOpacity: 1 }}
    />
    <path
      d="M64.824 2.62793L65.0814 1.9963L71.8188 4.74244L71.5614 5.37407L64.824 2.62793Z"
      fill="#FB554C"
      style={{ fill: '#FB554C', fillOpacity: 1 }}
    />
    <path
      d="M70.0088 0.445068L69.3772 0.187618L66.631 6.92501L67.2627 7.18246L70.0088 0.445068Z"
      fill="#FB554C"
      style={{ fill: '#FB554C', fillOpacity: 1 }}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.07571 7.81875C8.51501 7.81875 9.68179 6.65197 9.68179 5.21268C9.68179 3.77338 8.51501 2.6066 7.07571 2.6066C5.63642 2.6066 4.46964 3.77338 4.46964 5.21268C4.46964 6.65197 5.63642 7.81875 7.07571 7.81875ZM7.07571 8.4986C8.89048 8.4986 10.3616 7.02744 10.3616 5.21268C10.3616 3.39791 8.89048 1.92676 7.07571 1.92676C5.26095 1.92676 3.78979 3.39791 3.78979 5.21268C3.78979 7.02744 5.26095 8.4986 7.07571 8.4986Z"
      fill="#FDCB50"
      style={{ fill: '#FDCB50', fillOpacity: 1 }}
    />
    <ellipse
      cx="39.1552"
      cy="96.0546"
      rx="22.6864"
      ry="3.94546"
      fill="#FFF6EB"
      style={{ fill: '#FFF6EB', fillOpacity: 1 }}
    />
  </svg>
);

export default EmptyActivityIcon;
